import Phaser from 'phaser';
import { TextureFactory } from '../core/TextureFactory';
import { SceneKeys } from './SceneKeys';

/**
 * Genera todas las texturas placeholder (TextureFactory) antes de mostrar
 * el lobby. En v1 no hay assets externos que descargar, así que esto es
 * prácticamente instantáneo; queda el hook de `load` para cuando se sumen
 * assets CC0 reales (F3).
 */
export class PreloadScene extends Phaser.Scene {
  constructor() {
    super(SceneKeys.Preload);
  }

  preload(): void {
    const { width, height } = this.scale;
    const label = this.add
      .text(width / 2, height / 2, 'Cargando…', {
        fontFamily: 'monospace',
        fontSize: '20px',
        color: '#f4f0ff',
      })
      .setOrigin(0.5);
    this.load.on('progress', (value: number) => {
      label.setText(`Cargando… ${Math.round(value * 100)}%`);
    });
  }

  create(): void {
    TextureFactory.generateAll(this);
    this.scene.start(SceneKeys.Lobby);
  }
}
